/**
 * Soft interviewer access: verified flag OR active marketplace application profile.
 */
import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../api/client';

export default function useInterviewerAccess() {
  const { user } = useAuth();
  const [profileStatus, setProfileStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!user?.id) {
      setProfileStatus(null);
      return undefined;
    }
    if (user.is_interviewer) {
      setProfileStatus('verified');
      return undefined;
    }

    setLoading(true);
    api.marketplace
      .getMyProfile()
      .then((res) => {
        if (!cancelled) {
          setProfileStatus(res?.data?.verification_status || res?.data?.verificationStatus || null);
        }
      })
      .catch(() => {
        if (!cancelled) setProfileStatus(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [user?.id, user?.is_interviewer]);

  const activeApplicant = ['pending', 'under_review', 'verified'].includes(profileStatus);
  const canAccessDashboard = Boolean(user?.is_interviewer || activeApplicant);
  const showBecomeInterviewer = Boolean(user && !user.is_interviewer && !activeApplicant);

  return {
    loading,
    profileStatus,
    canAccessDashboard,
    showBecomeInterviewer,
  };
}
